<template>
<div class="chapter">
<div class="inner_page">
<a id="page_7">
<h1 class="toc-title">C<span class="smallcaps">ONTENTS</span></h1>
<hr style="border-top: solid 1px #B6B4AC; margin-top:0; margin-right:20em; margin-bottom:3em; margin-left:1em;"/>
</a><h2 class="toc"><a id="page_7"></a><a href="#/xhtml/05_Illustrations">List of Illustrations</a></h2>
<h2 class="toc"><span href="#/xhtml/06_Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Introduction" title="Link target outside of Sample">Introduction: <em class="italic">Alone in a Sea of Humanity</em></span></h2>
<h2 class="toc"><span href="#/xhtml/08_Origin" title="Link target outside of Sample"><em class="italic">Defending the Nation</em></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Use_This_Book" title="Link target outside of Sample">How to Use This Book</span></h2>
<h2 class="toc"><span href="#/xhtml/10_The_Artwork" title="Link target outside of Sample">The Artwork: <em class="italic">From Soot to Life</em></span></h2>
<h2 class="toc1"><span href="#/xhtml/11_Chapter01" title="Link target outside of Sample">Song of Trusting the Heart</span></h2>
<h2 class="toc2"><span href="#/xhtml/12_Appendix_I" title="Link target outside of Sample"><span class="smallcaps">APPENDICES</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Appendix_I" title="Link target outside of Sample">I. A Word’s Incredible Journey</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Appendix_II" title="Link target outside of Sample">II. Layers of Meaning: <em class="italic">The Art of Translating Song of Trusting the Heart</em></span></h2>
<h2 class="toc1"><span href="#/xhtml/14_Reading" title="Link target outside of Sample">Suggested Reading</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc"><span href="#/xhtml/16_The_Author" title="Link target outside of Sample">The Author</span></h2>
<h2 class="toc"><span href="#/xhtml/17_The_Artist" title="Link target outside of Sample">The Artist</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0ee7dd87